var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('h1',[_vm._v(_vm._s(_vm.meta.title))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }